import axios from "axios";
import { API_URL } from "../util/constants";
// configuration
const api = axios.create();
api.defaults.baseURL = API_URL;
api.defaults.headers.post["Content-Type"] = "application/json";
export default api;



// WEBPACK FOOTER //
// ./src/api/api.js